import axios from 'axios'


/**
 *
 * @status no delete
 * @class DomainService
 */
class DomainService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Lucia Alvarado
  * @description Get all domains
  * @date 12-03-2021
  * @status no delete
  * @param {String} token
  * @returns {Object}
  * @memberof DomainService
  */
  async getDomains(token) {
    let response = await axios.get(`${this.apiUrl}/domains-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })

    return response.data.data
  }

  /**
* @author Lucia Alvarado
* @description Create a new domain
* @date 12-03-2021
* @status no delete
* @param {String} token
* @param {String} domain
* @returns {Object}
* @memberof DomainService
*/
  async createDomain(domain, description, token) {
    let response = await axios.post(`${this.apiUrl}/domain-passthrough`,
      { domain, description },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

    return response.data
  }

  /**
* @author Lucia Alvarado
* @description Update a domain
* @date 12-03-2021
* @status no delete
* @param {String} token
* @param {String} domain
* @param {Number} clientId
* @param {Number} id
* @returns {Object}
* @memberof DomainService
*/
  async updateDomain(id, clientId, domain, description, token) {
    let response = await axios.put(`${this.apiUrl}/domain-passthrough`,
      { id, clientId, domain, description },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }


  /**
  * @author Lucia Alvarado
  * @description Delete a domain
  * @date 12-03-2021
  * @status no delete
  * @param {String} token
  * @param {Number} id
  * @param {Number} clientId
  * @returns {Object}
  * @memberof DomainService
  */

  async deleteDomain(id, clientId, token) {
    let response = await axios.delete(`${this.apiUrl}/domain-passthrough?id=${id}&clientId=${clientId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }

}

export { DomainService as default }